import { toast } from "react-toastify";

export const urlWithProtocolRegex = /^(https?:\/\/)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([/?].*)?$/i;

export const DRAWER_WIDTH = "854";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT_WITH_TIME = "YYYY-MM-DD HH:mm";
export const REPORT_DATE_FORMAT_WITH_TIME = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT_WITH_TIME_AND_SECONDS = "YYYY-MM-DD HH:mm:ss";
export const MULTISELECT_ALL_VALUE = "__ALL__";

export const COLORS = {
    green: "#52c41a",
    gold: "#FAAD14",
    magenta: "#eb2f96",
    purple: "#722ed1",
    red: "#f5222d",
    yellow: "#fadb14",
    blue: "#2f54eb",
    cyan: "#13c2c2",
    graphite: "#475569",
    bordeaux: "#9F1239",
};

export enum ChartTypes {
    Area = "area",
    Bar = "bar",
    Line = "line",
}

export const TABLE_DEFAULT_SCROLL_WIDTH = { x: "max-content" };

export const TOAST_TYPES = {
    INFO: "info" as const,
    SUCCESS: "success" as const,
    ERROR: "error" as const,
    WARNING: "warning" as const,
};

export type ToastType = keyof typeof toast;

export const COMMISSION_GROUP_USER_GROUP = "user-group";
export const COMMISSIONS_PRIORITY_SORT =
    "-offer.id,-conversion_type,-conversion_status,-conversion_source,-commission_group_id,weight";
